import React from "react";
import { IntegrationDetails } from "@SeemplicityDev/shared/integrations";
import { useParams } from "react-router-dom";
import TicketingSystemDetailsInstanceRow from "./TicketingSystemDetailsInstanceRow/TicketingSystemDetailsInstanceRow";
import { CardLoader, Loader } from "@SeemplicityDev/shared";

// Instance shape consumed here and passed to TicketingSystemDetailsInstanceRow.
// Mirrors the provider node merged into integrations upstream (AutomationSystems).
interface IntegrationInstance {
  id?: string;
  [key: string]: unknown;
}

// Integration is a merged Record<string, unknown> from AutomationSystems
// (systemDefaults + definitions + instances). Only `id` and `instances` are
// read here; the rest is spread through to <IntegrationDetails />.
interface Integration {
  id?: string;
  instances?: IntegrationInstance[];
  [key: string]: unknown;
}

export interface TicketingSystemIntegrationDetailsProps {
  mutateAllowed?: boolean;
  integrations?: Integration[];
  loading?: boolean;
  integrationDetailsAlertText?: string | React.ReactNode;
}

const TicketingSystemIntegrationDetails: React.FC<
  TicketingSystemIntegrationDetailsProps
> = ({ mutateAllowed, integrations, loading, integrationDetailsAlertText }) => {
  const { integrationId } = useParams<{ integrationId: string }>();

  if (loading) {
    return <CardLoader className={"integrations-ticket-wrap"} multiply={1} />;
  }

  if (!integrations?.length) {
    return <Loader text={"No matches found."} />;
  }

  const selectedIntegration = integrations?.find(
    (integration) => integration.id === integrationId
  );

  return (
    <IntegrationDetails
      // main passes `integration={selectedIntegration}`, but IntegrationDetails
      // only accepts `currentIntegration` — the prop is ignored at runtime and
      // `currentIntegration` stays undefined. Omitting it here is behaviorally
      // identical to main's JS.
      mutateAllowed={mutateAllowed}
      instances={
        <div className={"instances-wrapper"}>
          {selectedIntegration?.instances?.map((instance) => (
            <TicketingSystemDetailsInstanceRow instance={instance} />
          ))}
        </div>
      }
      // Prop is typed as ReactNode locally; IntegrationDetails narrows to string.
      integrationDetailsAlertText={integrationDetailsAlertText as string | undefined}
    />
  );
};

export default TicketingSystemIntegrationDetails;
